// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"e72c6908","70":"6af14e25","166":"8007856f","195":"dd812db4","507":"8122f246","582":"8122f246","745":"8122f246","842":"2f38c586","987":"8007856f"}[chunkId] + ".chunk.css";
};